<div class="h-screen w-full bg-blue-50">
  <div
    class="flex flex-col justify-center items-center h-full max-w-lg mx-auto gap-y-12 px-4"
  >
    <h1 class="text-3xl font-bold">Reset Password</h1>

    @if (paramsError()) {
      <p class="text-center">
        The password reset link is invalid. Please request a new link.
      </p>
    } @else {
      @if (mutation.status() === 'idle') {
        <p class="text-center">
          Enter your new password and confirm it to reset your password.
        </p>
        <form
          class="flex flex-col justify-start items-stretch w-full gap-y-4"
          [formGroup]="form"
          (submit)="onSubmit()"
        >
          <mat-form-field>
            <mat-label>Password</mat-label>
            <input
              matInput
              formControlName="password"
              type="password"
              placeholder="Password"
            />
            <mat-hint>Passwords must be at least 8 characters long</mat-hint>
            @if (form.get('password').hasError('required')) {
              <mat-error> Password is required </mat-error>
            }
            @if (form.get('password').hasError('minlength')) {
              <mat-error>
                Password must be at least 8 characters long
              </mat-error>
            }
          </mat-form-field>
          <mat-form-field>
            <mat-label>Confirm Password</mat-label>
            <input
              matInput
              formControlName="password_confirmation"
              type="password"
              placeholder="Confirm Password"
            />
            @if (form.get('password_confirmation').hasError('required')) {
              <mat-error> Confirm Password is required </mat-error>
            }
            @if (
              form.get('password_confirmation').hasError('confirmedValidator')
            ) {
              <mat-error> Passwords do not match </mat-error>
            }
          </mat-form-field>
          <button
            mat-raised-button
            color="primary"
            type="submit"
            [disabled]="form.valid === false"
            class="self-center"
          >
            Set Password
          </button>
        </form>
      } @else {
        @if (mutation.status() === 'success') {
          <p class="text-center">
            Your password has been reset. Please login with your new password.
          </p>
        }
        @if (mutation.status() === 'error') {
          <p class="text-center">
            An error occurred while resetting your password. This might be
            because the reset link is expired or invalid, please request a new
            link.
          </p>
        }
      }
    }
    <a [routerLink]="['/login']" class="text-blue-500">Back to login</a>
  </div>
</div>
